module.exports = "/static/assets/4da38973d5ffd15c54e80894d430288c.svg";